import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import StructuredData, {
  getOrganizationSchema,
  getWebSiteSchema,
  getWebPageSchema,
  getFAQSchema,
} from '@/components/feature/StructuredData';
import { articles, hotArticles, latestArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  useEffect(() => {
    document.title = '黑料718官网 - 黑料718入口与黑料718最新地址 | 黑料718app下载与每日吃瓜更新';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '黑料718官网入口聚合页，提供黑料718最新地址、app下载及718黑料内容浏览，方便用户快速访问并获取每日吃瓜爆料更新。');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '黑料718官网,黑料718入口,黑料718app,黑料718下载,黑料718最新地址,718黑料,黑料正能量718,吃瓜爆料');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://heiliao718.com');
    }
  }, []);

  const featuredArticles = hotArticles.slice(0, 3);
  const displayedArticles = latestArticles.slice(0, 8);

  return (
    <>
      <StructuredData data={getOrganizationSchema()} />
      <StructuredData data={getWebSiteSchema()} />
      <StructuredData
        data={getWebPageSchema(
          '黑料718官网 - 黑料718入口与黑料718最新地址',
          '黑料718官网入口聚合页，提供黑料718最新地址、app下载及718黑料内容浏览。',
          'https://heiliao718.com'
        )}
      />
      <StructuredData data={getFAQSchema()} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative pt-16">
            <div className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20geometric%20shapes%2C%20modern%20minimalist%20design%2C%20subtle%20texture%2C%20coral%20and%20cream%20tones%2C%20artistic%20composition%2C%20editorial%20background%2C%20clean%20aesthetic%2C%20no%20text&width=1600&height=800&seq=hero-bg-main&orientation=landscape"
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/25 via-foreground-950/15 to-background-50"></div>

              <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 pt-8 pb-20">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/10 border border-primary-300/30 rounded-full mb-6">
                  <i className="ri-fire-line text-primary-500 text-sm"></i>
                  <span className="text-xs font-medium text-primary-600">今日已更新 48 条爆料</span>
                </div>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
                  每日吃瓜
                  <br />
                  <span className="text-primary-500">料不能停</span>
                </h1>
                <p className="mt-5 text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
                  黑料718官网——最全吃瓜爆料聚合平台。娱乐圈八卦、网红翻车、
                  <br className="hidden sm:block" />
                  社会热点、综艺吃瓜，每日实时更新，带你吃遍天下瓜。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    下载黑料718 APP
                    <i className="ri-arrow-right-up-line"></i>
                  </Link>
                  <a
                    href="#latest"
                    className="inline-flex items-center gap-2 px-7 py-3 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    浏览最新爆料
                    <i className="ri-arrow-down-line"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Staggered Featured Cards */}
            <div className="relative -mt-24 px-4 md:px-6 pb-10">
              <div className="max-w-5xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                  {featuredArticles.map((article, idx) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className={`group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                        idx === 1 ? 'md:-mt-8' : 'md:mt-0'
                      }`}
                    >
                      <div className="relative aspect-[4/3] overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          title={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                        <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                          热门爆料
                        </span>
                      </div>
                      <div className="p-4 md:p-5">
                        <h2 className="text-sm md:text-base font-heading font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                          {article.title}
                        </h2>
                        <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                          <span>{article.author}</span>
                          <span>{article.publishDate}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Latest Articles Grid */}
          <section id="latest" className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    最新爆料
                  </h2>
                  <p className="text-xs text-foreground-500 mt-1">实时追踪，不错过每一条瓜</p>
                </div>
                <Link
                  to="/category/social-hot-topics"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap flex items-center gap-1"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {displayedArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
              <div className="text-center mt-8">
                <Link
                  to="/category/celebrity-gossip"
                  className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  加载更多爆料
                  <i className="ri-arrow-down-line"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* Category Feature Grid */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  分类导航
                </span>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  探索你感兴趣的瓜
                </h2>
                <p className="text-xs text-foreground-500 mt-1">四大频道，满足你的吃瓜需求</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {categories.map((cat, idx) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                      idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
                    }`}
                  >
                    <div className={`relative ${idx === 0 ? 'aspect-[16/9] lg:aspect-auto lg:h-full' : 'aspect-[4/3]'}`}>
                      <img
                        src={cat.image}
                        alt={cat.name}
                        title={`${cat.name} - 黑料718`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 text-sm">
                            <i className={cat.icon}></i>
                          </span>
                          <span className="text-xs text-background-50/80">{cat.count} 条爆料</span>
                        </div>
                        <h3 className="text-lg md:text-xl font-heading font-bold text-background-50">
                          {cat.name}
                        </h3>
                        {idx === 0 && (
                          <p className="text-xs text-background-50/70 mt-1 line-clamp-2">
                            {cat.description}
                          </p>
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Articles Section */}
          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    热门爆料
                  </h2>
                  <p className="text-xs text-foreground-500 mt-1">大家都在看的精彩内容</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                {hotArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer p-4"
                  >
                    <div className="relative w-full sm:w-44 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md whitespace-nowrap">
                        热门
                      </span>
                    </div>
                    <div className="flex-1 min-w-0 flex flex-col justify-between">
                      <div>
                        <span className="text-xs text-primary-500 font-medium">{article.category}</span>
                        <h3 className="text-sm font-heading font-semibold text-foreground-950 leading-snug line-clamp-2 mt-1 group-hover:text-primary-500 transition-colors duration-200">
                          {article.title}
                        </h3>
                        <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                          {article.excerpt}
                        </p>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-foreground-400 mt-2">
                        <span>{article.author}</span>
                        <span>{article.publishDate}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.readCount >= 10000
                            ? `${(article.readCount / 10000).toFixed(1)}万`
                            : article.readCount}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* APP Download CTA */}
          <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="rounded-2xl overflow-hidden mb-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20news%20app%20interface%20on%20screen%2C%20placed%20on%20minimalist%20desk%20with%20coffee%20cup%2C%20warm%20morning%20light%2C%20modern%20workspace%2C%20clean%20aesthetic%2C%20lifestyle%20photography%2C%20soft%20shadows&width=1200&height=500&seq=cta-app-banner&orientation=landscape"
                  alt="黑料718 APP"
                  title="黑料718 APP下载"
                  className="w-full h-48 md:h-64 object-cover object-top"
                />
              </div>
              <div className="text-center">
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
                  随时随地，<span className="italic text-primary-500 font-normal">吃瓜</span>不停歇
                </h2>
                <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto leading-relaxed">
                  下载黑料718 APP，第一时间获取爆料推送。支持安卓与iOS双平台，<strong>每日更新</strong>，吃瓜快人一步。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-android-line"></i>
                    Android 下载
                  </Link>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-apple-line"></i>
                    iOS 下载
                  </Link>
                </div>
                <p className="mt-3 text-xs text-foreground-400">
                  已有 <strong className="text-foreground-600">3,280,000+</strong> 用户正在使用黑料718
                </p>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}